'use client';

import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';

import { NewBadgeIcon } from '../Icons';

interface NewsItem {
  id: number;
  text: string;
  href: string;
}

interface RealtimeRegionInfoClientProps {
  updatedAt: string;
  news: NewsItem[];
  isLogin: boolean;
}

export const RealtimeRegionInfoClient = ({
  updatedAt,
  news,
  isLogin,
}: RealtimeRegionInfoClientProps) => {
  return (
    <section>
      <div className="px-28 pb-16">
        <h2 className="font-700 text-Gray-900 typo-body2">지역 인기 소식</h2>
        <div className="flex items-center justify-between">
          <p className="font-500 text-Gray-600 typo-body4">
            {isLogin
              ? '내 지역의 새로운 소식이에요'
              : '지금 인기있는 지역 소식이에요'}
          </p>
          <span className="font-400 text-Gray-550 typo-caption1">
            {updatedAt} 업데이트
          </span>
        </div>
      </div>

      <div className="px-20">
        <div
          className="rounded-large bg-Gray-white shadow-home"
          style={{ boxShadow: '8px 10px 40px 0px rgba(0, 0, 0, 0.03)' }}
        >
          {news.map((item, index) => (
            <CustomLink
              key={item.id}
              href={item.href}
              className={cn(
                'flex items-center justify-between px-20',
                'transition-colors duration-150',
                'hover:bg-Gray-25 active:bg-Gray-50',
                index === 0 && 'rounded-t-large pt-16',
                index > 0 && 'pt-12',
                index === news.length - 1 && 'rounded-b-large pb-16',
              )}
            >
              <div
                className={cn(
                  'flex w-full items-center',
                  index < news.length - 1 && 'border-b border-Gray-50 pb-12',
                )}
              >
                <div className="flex flex-1 items-center gap-4">
                  <NewBadgeIcon />
                  <p className="line-clamp-1 flex-1 font-400 text-Gray-800 typo-body4">
                    {item.text}
                  </p>
                </div>
                <SvgChevronright className="size-16 text-Gray-500" />
              </div>
            </CustomLink>
          ))}
        </div>
      </div>
    </section>
  );
};
